interface Props {
  viewBox?: string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const ExternalLinkWhite = (props: Props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.333 5v1.667H4.167v9.166h9.166v-4.166H15v5a.833.833 0 0 1-.833.833H3.333a.833.833 0 0 1-.833-.833V5.833A.833.833 0 0 1 3.333 5h5ZM17.5 2.5v6.667h-1.667V5.344L9.34 11.84l-1.178-1.178 6.493-6.494h-3.82V2.5H17.5Z"
      fill={props?.color || "#ffffff"}
    />
  </svg>
);
